export default function IconSuitcase() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 28.985 26.087"
    >
      <path
        d="M7.73 5.797v-2.9C7.73 1.297 9.024 0 10.622 0h7.74c1.597 0 2.893 1.3 2.893 2.897v2.9h4.833c1.6 0 2.896 1.294 2.896 2.896v14.498c0 1.598-1.3 2.896-2.896 2.896H2.897A2.894 2.894 0 0 1 0 23.191V8.693c0-1.598 1.3-2.896 2.896-2.896H7.73Zm0 18.358h13.526V7.73H7.73v16.425Zm15.458 0h2.901c.53 0 .964-.433.964-.964V8.693a.962.962 0 0 0-.964-.963h-2.9v16.425ZM5.798 7.73H2.896a.966.966 0 0 0-.965.963v14.498c0 .534.43.964.965.964h2.9V7.729Zm3.864-1.933h9.662v-2.9a.965.965 0 0 0-.962-.965h-7.739a.962.962 0 0 0-.961.965v2.9Z"
        data-name="Layer 1"
        style={{
          fill: "var(--color-primary)",
          strokeWidth: 0,
        }}
      />
    </svg>
  );
}
